<template>
  <div>
    <vb-form-row item-name="郵便番号" :required="true">
      <template #input>
        <v-sheet width="100%" :max-width="$vuetify.breakpoint.mdAndUp? 240: null">
          <validation-provider v-slot="{ errors }" name="郵便番号" rules="required|digits:7" vid="postcode">
            <v-text-field
              :value="formItemsGetter.postcode"
              maxlength="7"
              @input="clearAddressInputValue(); formItemsSetter({name:'postcode', value: stripHyphen($event)})"
              @blur="suggestAddress($event.target.value);"
              :error-messages="errors"
              label="郵便番号"
              name="postcode"
              outlined
              required
              dense
              height="44px"
              :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              hide-details="auto"
              solo
              flat
              type="text"
              inputmode="numeric"
            >
              <template #label><span class="text-body-2">郵便番号</span></template>
            </v-text-field>
          </validation-provider>
        </v-sheet>
      </template>
    </vb-form-row>

    <vb-form-row item-name="都道府県" :required="true">
      <template #input>
        <v-sheet width="100%" :max-width="$vuetify.breakpoint.mdAndUp? 240: null">
          <validation-provider v-slot="{ errors }" name="都道府県" rules="required|max:7" vid="prefecture">
            <v-text-field
              :value="formItemsGetter.addressPrefecture"
              maxlength="4"
              @input="formItemsSetter({name:'addressPrefecture', value: $event})"
              name="address_prefecture"
              outlined
              required
              dense
              height="44px"
              :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              readonly
              hide-details="auto"
              solo
              flat
            >
              <template #label><span class="text-body-2">都道府県</span></template>
            </v-text-field>
          </validation-provider>
          <p class="grey--text text-caption">※郵便番号を入れると自動で入力されます</p>
        </v-sheet>
      </template>
    </vb-form-row>

    <vb-form-row item-name="市区町村番地" :required="true">
      <template #input>
        <v-sheet width="100%" :max-width="$vuetify.breakpoint.mdAndUp? 640: null">
          <validation-provider
            v-slot="{ errors }"
            name="市区町村番地"
            ref="address_local_1"
            mode="passive"
            :rules="getAddressLocal1Rules"
            vid="localAddress1"
          >
            <v-text-field
              :value="formItemsGetter.addressLocal1"
              :maxlength="getAddressMaxLength"
              @input="formItemsSetter({name:'addressLocal1', value: $event})"
              @blur="$refs.address_local_1.validate();"
              :error-messages="errors"
              name="address_local_1"
              outlined
              required
              dense
              height="44px"
              :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              id="address-local-1"
              hide-details="auto"
              solo
              flat
            >
              <template #label><span class="text-body-2">例）芭部区芭部ヶ谷1-2-3</span></template>
            </v-text-field>
          </validation-provider>
          <p class="grey--text text-caption">※市区町村番地は必ず入力してください</p>
        </v-sheet>
      </template>
    </vb-form-row>

    <vb-form-row item-name="建物名">
      <template #input>
        <v-sheet width="100%" :max-width="$vuetify.breakpoint.mdAndUp? 640: null">
          <validation-provider
            v-slot="{ errors }"
            name="建物名"
            :rules="getAddressLocal2Rules"
            vid="localAddress2"
          >
            <v-text-field
              :value="formItemsGetter.addressLocal2"
              :maxlength="getAddressMaxLength"
              @input="formItemsSetter({name:'addressLocal2', value: $event})"
              @blur="$refs.address_local_1.validate();"
              :error-messages="errors"
              label="建物名"
              name="address_local_2"
              outlined
              required
              dense
              height="44px"
              :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              hide-details="auto"
              solo
              flat
            >
              <template #label><span class="text-body-2">例）馬篭ビル101（任意）</span></template>
            </v-text-field>
          </validation-provider>
          <p class="grey--text text-caption">※建物名や部屋番号は省略せず入力してください</p>
        </v-sheet>
      </template>
    </vb-form-row>
  </div>
</template>

<script>
import InputValueConversion from "../../../libs/InputValueConversion.js";
import VbFormRow from "../../molecules/buy/vb-form-row.vue";
import {extend} from "vee-validate";

export default {
  name: "pickup-address",
  components: {VbFormRow, InputValueConversion},
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formLabelsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  data() {
    return {
    }
  },
  created() {
    extend('is_not_same_as_suggested', () => {
      if (this.formItemsGetter.isAddressSameAsSuggested) {
        return '市区町村番地は必ず入力してください';
      }
      return true;
    });
  },
  computed: {
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    },
    getAddressMaxLength() {
      return 50;
    },
    getAddressLocal1Rules() {
      const baseRules = "required|jis_level2_char|is_not_same_as_suggested"
        + "|max:" + this.getAddressMaxLength;

      if (this.isCharibon) {
        // charibon_address内で最大長チェックをしている
        return baseRules + "|charibon_address:@postcode,@prefecture,@localAddress2," + this.$siteCode + "," + this.formItemsGetter.supportGroupId;
      }

      return baseRules + "|address_length:@prefecture,@localAddress2|address:@postcode,@prefecture,@localAddress2";
    },
    getAddressLocal2Rules() {
      const baseRules = "jis_level2_char";
      return baseRules + "|max:" + this.getAddressMaxLength;
    },
  },
  methods: {
    focusBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (event.target.value === "") {
        targetNode.classList.add('input-bg-white');
      }
    },
    blurBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (errors) {
        targetNode.classList.remove('input-bg-white');
      }
    },
    async suggestAddress(v) {
      await this.formItemsSetter({name: 'postcode', value: this.toHalfSize(v)});

      const postcode = this.formItemsGetter.postcode;
      const pattern = /^\d*$/; // 0以上の整数 0始まりもOK
      if (postcode && pattern.test(postcode)) {
        axios.post('/api/findAddressByPostcode', {
          postcode: postcode
        }).then(response => {
          this.formItemsSetter({name: 'addressPrefecture', value: response.data.state});
          this.formItemsSetter({name: 'addressLocal1', value: response.data.address1});

          if (response.data.address1) {
            this.formLabelsSetter({name: 'suggestedAddress', value: response.data.address1})
            document.getElementById('address-local-1').focus();
          }
        });
      }
    },
    stripHyphen(value) {
      return InputValueConversion.hyphenRemoval(value)
    },
    toHalfSize(value) {
      return InputValueConversion.toHalfSize(value);
    },
    clearAddressInputValue() {
      this.formItemsSetter({name: 'addressPrefecture', value: ''});
      this.formItemsSetter({name: 'addressLocal1', value: ''});
    }
  },
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 0;
  margin-bottom: 0;
}
</style>